// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PhotoGalleryController from "./photo_gallery_controller"
application.register("photo-gallery", PhotoGalleryController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)
